<template>
  <v-container>
    <v-layout row>
      <v-flex>
        <v-card-text>
          <v-container>
            <h2>Tutu Order (Buy Only)</h2>
            <v-btn to="/iabf/admin/costume-orders">
              &lt; Back to Costume Orders
            </v-btn>
            <v-btn @click="downloadCSV" style="margin-left: 12px;">
              Download CSV
            </v-btn>
            <vue-good-table
              :columns="columns"
              :rows="rows"
              :line-numbers="true"
              :search-options="{
                enabled: true,
                placeholder: 'Search dancers',
              }"
            >
              <div slot="emptystate">
                No tutu orders found!
              </div>
              <template
                slot="table-row"
                slot-scope="props"
              >
                <span v-if="props.column.field === 'color'">
                  <v-select
                    v-if="props.row.waltzColorOptions.length > 0"
                    v-model="props.row.color"
                    :items="[{ text: '(none)', value: '' }].concat(props.row.waltzColorOptions.map((c, i) => ({ text: (i+1) + '. ' + c + (waltzColorCounts[c] ? ' (' + waltzColorCounts[c] + ')' : ''), value: c })))"
                    dense
                    hide-details
                    @change="assignColor(props.row, 'assignedWaltzColor', props.row.color)"
                    :style="props.row.color ? { fontWeight: 'bold' } : {}"
                  ></v-select>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </v-container>
        </v-card-text>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style>
  h2 {
    font-family: Quattrocento;
    font-weight: 400;
    font-size: 39px;
    letter-spacing: -.02em;
    line-height: 1em;
  }

  .vgt-table, v-btn {
    font-family: Fanwood Text;
  }

  .vgt-table thead {
    font-size: 1.2em !important;
  }
</style>

<script>
  import 'vue-good-table/dist/vue-good-table.css'
  import { VueGoodTable } from 'vue-good-table'

  export default {
    components: {
      VueGoodTable
    },
    data () {
      return {
        columns: [
          { label: 'Type', field: 'type' },
          { label: 'Dancer', field: 'dancer' },
          { label: 'Color Choices', field: 'colorChoices' },
          { label: 'Assigned Color', field: 'color' },
          { label: 'Bust (in)', field: 'bustIn' },
          { label: 'Waist (in)', field: 'waistIn' },
          { label: 'Hips (in)', field: 'hipsIn' },
          { label: '1/2 Girth (in)', field: 'halfGirthIn' },
          { label: 'Girth (in)', field: 'girthIn' },
          { label: 'Height (in)', field: 'heightIn' }
        ],
        rows: []
      }
    },
    created () {
      this.$store.dispatch('loadIABFDancers').then(() => {
        this.$store.getters.loadedIABFDancers.forEach((dancer) => {
          this.addBuyRows(dancer)
        })
      })
    },
    computed: {
      waltzColorCounts () {
        const counts = {}
        const dancers = this.$store.getters.loadedIABFDancers || []
        dancers.forEach(d => {
          if (d.assignedWaltzColor) {
            counts[d.assignedWaltzColor] = (counts[d.assignedWaltzColor] || 0) + 1
          }
          const woh = d.waltzOfHours || {}
          if (woh.participating && woh.tutuChoice === 'own' && woh.tutuColor && !d.assignedWaltzColor) {
            counts[woh.tutuColor] = (counts[woh.tutuColor] || 0) + 1
          }
        })
        return counts
      }
    },
    methods: {
      toCm (value, unit) {
        if (!value) return ''
        const num = parseFloat(value)
        if (isNaN(num)) return ''
        if (unit === 'inches') return (num * 2.54).toFixed(1)
        return num.toFixed(1)
      },
      toInches (value, unit) {
        if (!value) return ''
        const num = parseFloat(value)
        if (isNaN(num)) return ''
        if (unit === 'cm') return (num / 2.54).toFixed(1)
        return num.toFixed(1)
      },
      downloadCSV () {
        const headers = ['Name', 'Tutu Type', 'Assigned Color', 'Bust (cm)', 'Waist (cm)', 'Hips (cm)', '1/2 Girth (cm)', 'Girth (cm)', 'Height (cm)']
        const csvRows = [headers.join(',')]
        this.rows.forEach(row => {
          const cols = [
            '"' + (row.dancer || '').replace(' (BORROW)', '').replace(/"/g, '""') + '"',
            '"' + (row.type || '').replace(/"/g, '""') + '"',
            '"' + (row.color || '').replace(/"/g, '""') + '"',
            row.bust,
            row.waist,
            row.hips,
            row.halfGirth,
            row.girth,
            row.height
          ]
          csvRows.push(cols.join(','))
        })
        const blob = new Blob([csvRows.join('\n')], { type: 'text/csv' })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = 'tutu-orders.csv'
        a.click()
        URL.revokeObjectURL(url)
      },
      dancerName (dancer) {
        return dancer.firstName + ' ' + (dancer.lastName ? dancer.lastName.charAt(0) + '.' : '')
      },
      assignColor (row, field, color) {
        this.$store.dispatch('assignCostumeColor', { id: row.id, field: field, color: color })
      },
      addBuyRows (dancer) {
        const woh = dancer.waltzOfHours || {}
        const aiw = dancer.aliceInWonderland || {}
        const gw = dancer.garlandWaltz || {}
        const m = dancer.sharedMeasurements || {}
        const unit = m.unit || 'inches'
        const name = this.dancerName(dancer)

        const waltzColorOptions = [woh.colorPref1, woh.colorPref2, woh.colorPref3].filter(c => c)

        const measurements = {
          bust: this.toCm(m.bust, unit),
          waist: this.toCm(m.waist, unit),
          hips: this.toCm(m.hip, unit),
          halfGirth: this.toCm(m.halfGirth, unit),
          girth: this.toCm(m.girth, unit),
          height: this.toCm(m.height, unit),
          bustIn: this.toInches(m.bust, unit),
          waistIn: this.toInches(m.waist, unit),
          hipsIn: this.toInches(m.hip, unit),
          halfGirthIn: this.toInches(m.halfGirth, unit),
          girthIn: this.toInches(m.girth, unit),
          heightIn: this.toInches(m.height, unit)
        }

        // Waltz of Hours buy
        if (woh.participating && woh.tutuChoice === 'buy') {
          this.rows.push({
            id: dancer.id,
            type: 'Colorful Pancake + Bodice',
            dancer: name,
            waltzColorOptions: waltzColorOptions,
            colorChoices: waltzColorOptions.map((c, i) => (i + 1) + '. ' + c).join(', '),
            color: dancer.assignedWaltzColor || '',
            ...measurements
          })
        }

        // Waltz of Hours borrow — ordered new
        if (woh.participating && woh.tutuChoice === 'borrow' && dancer.borrowedWaltzTutuOrdered) {
          this.rows.push({
            id: dancer.id,
            type: 'Colorful Pancake + Bodice',
            dancer: name + ' (BORROW)',
            waltzColorOptions: waltzColorOptions,
            colorChoices: waltzColorOptions.map((c, i) => (i + 1) + '. ' + c).join(', '),
            color: dancer.assignedWaltzColor || '',
            ...measurements
          })
        }

        // Alice Pointe buy
        if (aiw.participating && aiw.role === 'Pointe' && aiw.tutuChoice === 'buy') {
          this.rows.push({
            id: dancer.id,
            type: 'White Pancake',
            dancer: name,
            waltzColorOptions: [],
            colorChoices: '',
            color: '',
            ...measurements
          })
        }

        // Alice Pointe borrow — ordered new
        if (aiw.participating && aiw.role === 'Pointe' && aiw.tutuChoice === 'borrow' && dancer.borrowedAliceTutuOrdered) {
          this.rows.push({
            id: dancer.id,
            type: 'White Pancake',
            dancer: name + ' (BORROW)',
            waltzColorOptions: [],
            colorChoices: '',
            color: '',
            ...measurements
          })
        }

        // Alice Flat Ladies buy
        if (aiw.participating && aiw.role === 'Flat Ladies' && aiw.tutuChoice === 'buy') {
          this.rows.push({
            id: dancer.id,
            type: 'White Romantic',
            dancer: name,
            waltzColorOptions: [],
            colorChoices: '',
            color: '',
            ...measurements
          })
        }

        // Alice Flat Ladies borrow — ordered new
        if (aiw.participating && aiw.role === 'Flat Ladies' && aiw.tutuChoice === 'borrow' && dancer.borrowedAliceTutuOrdered) {
          this.rows.push({
            id: dancer.id,
            type: 'White Romantic',
            dancer: name + ' (BORROW)',
            waltzColorOptions: [],
            colorChoices: '',
            color: '',
            ...measurements
          })
        }

        // Garland Ladies (not shared with Alice) buy
        if (gw.participating && gw.role === 'Ladies' && !gw.tutuSharedWithAlice && gw.tutuChoice === 'buy') {
          this.rows.push({
            id: dancer.id,
            type: 'White Romantic',
            dancer: name,
            waltzColorOptions: [],
            colorChoices: '',
            color: '',
            ...measurements
          })
        }

        // Garland Ladies borrow — ordered new
        if (gw.participating && gw.role === 'Ladies' && !gw.tutuSharedWithAlice && gw.tutuChoice === 'borrow' && dancer.borrowedGarlandTutuOrdered) {
          this.rows.push({
            id: dancer.id,
            type: 'White Romantic',
            dancer: name + ' (BORROW)',
            waltzColorOptions: [],
            colorChoices: '',
            color: '',
            ...measurements
          })
        }
      }
    }
  }
</script>
